import PropTypes from "prop-types";
import { useState } from "react";
import { Col, Row } from "reactstrap";

import { MUIIcons, P } from "../../AbstractElements";
import CardHeaderDropDown from "../../CommonElements/CommonCardHeader/CardHeaderDropDown";
import CommonModal from "../../CommonElements/Modal";
import {
  AddedOn,
  Confirm,
  CreatedBy,
  DeleteUserGroupHeader,
  DeleteUserGroupMessage,
  NoOfUser,
} from "../../utils/Constant";
import useIsMobile from "../../utils/helper/responsive";

const EnrolledUserGroups = ({
  heading,
  noOfGroups,
  noOfAddedGroups,
  createdBy,
  addedOn,
  firstItem,
  secondItem,
  onDropdownClick,
  onDeleteClick,
  toggleSliderModal,
  showDelete,
}) => {
  const isMobile = useIsMobile();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  return (
    <>
      <CommonModal
        sizeTitle={DeleteUserGroupHeader}
        modalBodyClassName=""
        isOpen={isModalOpen}
        toggle={toggleModal}
        backdrop="static"
        size="lg"
        showFooter
        onPrimaryBtnClick={async () => {
          onDeleteClick();
          toggleModal();
        }}
        primaryBtnText={Confirm}
      >
        {DeleteUserGroupMessage}
      </CommonModal>
      <Row className="align-items-center justify-content-between">
        <Col lg={"3"}>
          <div className="d-flex gap-2 align-items-center">
            <div className="fw-bold text-black">{heading}</div>
            <MUIIcons
              iconName="InfoOutlined"
              size={18}
              onClick={toggleSliderModal}
              className="pointer"
            />
          </div>
          <P className="mt-2">{`${NoOfUser} :  ${noOfAddedGroups ? noOfAddedGroups + " | " + noOfGroups : noOfGroups}`}</P>
        </Col>

        {!showDelete && (
          <Col lg={"8"} className={"text-gray"}>
            <Row>
              <Col className={isMobile && "mt-2"} lg={"6"}>
                <div className="d-flex gap-2 align-items-center text-muted">
                  <MUIIcons iconName="PersonOutline" size={20} />
                  {`${CreatedBy} :`}
                  <span className="ms-2">
                    <span className="text-dark fw-bold">
                      {createdBy && `${createdBy}`}
                    </span>
                  </span>
                </div>
              </Col>

              <Col className={isMobile && "mt-2"} lg={"6"}>
                <div className="d-flex align-items-center">
                  <span className={!isMobile && "ms-2"}>
                    {AddedOn}:{" "}
                    <span className="text-dark fw-bold">{addedOn || "-"}</span>
                  </span>
                </div>
              </Col>
            </Row>
          </Col>
        )}

        {!showDelete && (
          <Col lg="1" className="d-flex align-items-center justify-content-end">
            <CardHeaderDropDown
              mainTitle
              firstItem={firstItem}
              {...(secondItem && { secondItem })}
              onClickItem={onDropdownClick}
            />
          </Col>
        )}
        {showDelete && (
          <Col lg="1" className="d-flex align-items-center justify-content-end">
            <MUIIcons
              iconName="DeleteOutlineOutlined"
              className="primary-icon-color pointer"
              size={24}
              onClick={toggleModal}
            />
          </Col>
        )}
      </Row>
    </>
  );
};

export default EnrolledUserGroups;

EnrolledUserGroups.propTypes = {
  heading: PropTypes.string.isRequired,
  noOfGroups: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  noOfAddedGroups: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  createdBy: PropTypes.string,
  addedOn: PropTypes.string,
  firstItem: PropTypes.string,
  secondItem: PropTypes.string,
  onDropdownClick: PropTypes.func,
  toggleSliderModal: PropTypes.func,
  showDelete: PropTypes.bool,
  onDeleteClick: PropTypes.func,
};
